import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';
import ChartPie from '../js/ChartPie';
import ChartGauge from '../js/ChartGauge';
import ChartDonut from '../js/ChartDonut';
import ChartLine from '../js/ChartLine';

export default function OviewTeam() {
    useEffect(() => {
        document.title = "Team"; // Set the tab name
    }, []);

    const [dataCounts, setDataCounts] = useState({
        staffTotal: 0,
        taskRateCompleted: 0,
        timeAverageResponse: 0,
        requestedCompleted: 0
    });

    // const [example_data, setExample] = useState({

    // });

    // for testing, set team_data initial state to example_data
    // const [team_data, setTeam] = useState(example_data);

    // const [searchValue, setSearchValue] = useState("");

    const [updateTrigger, setUpdateTrigger] = useState(false);

    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    // Helper function to format percentage
    const formatPercentage = (value) => {
        return `${(value * 100).toFixed(1)}%`;
    };

    // Helper function to format time in minutes and hours
    const formatTime = (minutes) => {
        if (minutes >= 60) {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes > 0 ? `${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}` : ''}`;
        }
        return `${minutes} minute${minutes > 1 ? 's' : ''}`;
    };

    useEffect(() => {
        const fetchDataCounts = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api/your-endpoint.php'); // TODO refer to api folder in htdocs
            setDataCounts({
              staffTotal: abbreviateNumber(response.data.staffTotal),
              taskRateCompleted: formatPercentage(response.data.taskRateCompleted),
              timeAverageResponse: formatTime(response.data.timeAverageResponse),
              requestedCompleted: abbreviateNumber(response.data.requestedCompleted)
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes
  
    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };
  
    // const handleSearchChange = (e) => {
    //     const searchQuery = e.target.value.toLowerCase();
    //     setSearchValue(searchQuery);

    //     // for testing, filter from example_data
    //     const filteredBySearch = paginatedTeam.filter((request) =>
    //     Object.values(request).some((val) =>
    //         String(val).toLowerCase().includes(searchValue.toLowerCase())
    //     )
    //     );

    //     setTeam(filteredBySearch);
    //     setPageNow(1);
    // }

    // const [pageNow, setPageNow] = useState(1);
    // const rowsNow = 15;
    // const indxLast = pageNow * rowsNow;
    // const indxFirst = indxLast - rowsNow;
  
    // const paginatedTeam = team_data.slice(indxFirst, indxLast);
    // const pageTotal = Math.ceil(team_data.length / rowsNow);
    // const pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
  
    // const pagePrev = () => {
    //   if (pageNow > 1) setPageNow(pageNow - 1);
    // };
  
    // const pageNext = () => {
    //   if (pageNow < pageTotal) setPageNow(pageNow + 1);
    // };
  
    // const changePage = (id) => {
    //   setPageNow(id);
    // };

    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    /* example graph data */

    // donut/bar data
    const example1 = [
        {property: 'Queue', value: 620},
        {property: 'In Progress', value: 1200},
        {property: 'Done', value: 8000}
    ] 

    const example2 = [
        {property: 'In Review', value: 500},
        {property: 'Archived', value: 2500},
        {property: 'Cancelled', value: 3600}
    ]

    // pie data
    const example3 = [
        {property: 'Regular', value: 11},
        {property: 'Admin', value: 3},
        {property: 'Support', value: 4}
    ] 

    const example4 = [
        {property: 'Paid', value: 0},
        {property: 'Not Paid', value: 0},
        {property: 'Pending Balance', value: 0}
    ]

    // line data
    const example5 = [
        {date: new Date("2024-04-01"), value: 100},
        {date: new Date("2024-05-01"), value: 120},
        {date: new Date("2024-06-01"), value: 140},
        {date: new Date("2024-07-01"), value: 160},
        {date: new Date("2024-08-01"), value: 180}
    ] 

    const example6 = [
        {date: new Date("2024-05-01"), value: 90},
        {date: new Date("2024-04-01"), value: 110},
        {date: new Date("2024-06-01"), value: 130},
        {date: new Date("2024-07-01"), value: 150},
        {date: new Date("2024-08-01"), value: 170}
    ]



    useEffect(() => {
      const fetchDataCounts = async () => {
        try {
          const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
          setDataCounts(response.data);
        } catch (error) {
          //console.error("Error fetching data counts:", error);
        }
      };
  
      fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    useEffect(()=>{
        // TODO axios get from users in db

    }, []);

    return (
        <div>
            <section className='dash_overview'>
                <article className='stat_box standalone'>
                    <h6 className='title'>Total&nbsp;Staff</h6>
                    <p className='title body'>{dataCounts.staffTotal} </p>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>Overall&nbsp;Task&nbsp;Completion&nbsp;Rate</h6>
                    <p className='title body'>{dataCounts.taskRateCompleted}</p>
                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>Avg.&nbsp;Response&nbsp;Time&nbsp;Today</h6>
                    <p className='title body'>{dataCounts.timeAverageResponse} </p>

                </article>

                <article className='stat_box standalone'>
                    <h6 className='title'>Completed&nbsp;Requests</h6>
                    <p className='title body'>{dataCounts.requestedCompleted}</p>
                </article>
            </section>

            <section className='dash_overview content'>
                <article className='stats'>
                    <h5 className='title'>Tasks by Status</h5>
                    <article className='stat_box'>
                        <ChartDonut dataProps1={example1} dataProps2={example2} />
                    </article>
                </article>
                
                {/* TODO css enlarge when hover + pointer cursor */}
                <article className='stats' onClick={() => handleNavigation('/manage/users')}>
                    <h5 className='title'>Team Roles</h5>
                    <article className='stat_box'>
                        <ChartPie dataProps={example3} />
                    </article>
                </article>

                <article className='stats wide'>
                    <h5 className='title'>New Transactions VS Closed</h5>
                    <article className='stat_box'>
                        <ChartLine dataProps1={example5} dataProps2={example6} nameProps1='Open' nameProps2='Closed' />
                    </article>
                </article>

                {/* <article className='stats'>
                    <h5 className='title'>Top 5 Requested Documents</h5>
                    <article className='stat_box'>
                        
                    </article>
                </article> */}
            </section>
        </div>
    )
}